
/**Removes the hash from the URL */
const removeHash = () => {
    const { pathname, search } = window.location;
    window.history.pushState("", document.title, pathname + search);
};

export default removeHash;